import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_API_URL || "http://localhost:6000";

const PaymentPage = () => {
  const [payData, setPayData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${BACKEND}/api/inicis/prepare`)
      .then((res) => {
        setPayData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("결제 정보를 불러오지 못했습니다.");
        setLoading(false);
      });
  }, []);

  const handlePay = () => {
    if (window.INIStdPay) {
      window.INIStdPay.pay("SendPayForm_id");
    } else {
      alert("INIStdPay.js가 로드되지 않았습니다.");
    }
  };

  if (loading)
    return <div className="text-center mt-5">Loading payment...</div>;
  if (error) return <div className="alert alert-danger mt-5 mx-3">{error}</div>;

  return (
    <div className="container mt-5">
      <h4>결제 요청</h4>

      {/* Hidden form submitted directly to Inicis via INIStdPay.js */}
      <form id="SendPayForm_id" method="post">
        <input type="hidden" name="version" value="1.0" />
        <input type="hidden" name="mid" value={payData.mid} />
        <input type="hidden" name="oid" value={payData.oid} />
        <input type="hidden" name="price" value={payData.price} />
        <input type="hidden" name="timestamp" value={payData.timestamp} />
        <input type="hidden" name="use_chkfake" value={payData.use_chkfake} />
        <input type="hidden" name="signature" value={payData.signature} />
        <input type="hidden" name="verification" value={payData.verification} />
        <input type="hidden" name="mKey" value={payData.mKey} />
        <input type="hidden" name="currency" value="WON" />
        <input type="hidden" name="returnUrl" value={`${window.location.origin}/api/inicis/return`} />
        <input type="hidden" name="closeUrl" value={`${window.location.origin}/close.html`} />
        <input type="hidden" name="gopaymethod" value={payData.gopaymethod} />
        <input type="hidden" name="goodname" value={payData.goodname} />
        <input type="hidden" name="buyername" value={payData.buyername} />
        <input type="hidden" name="buyertel" value={payData.buyertel} />
        <input type="hidden" name="buyeremail" value={payData.buyeremail} />
        <input type="hidden" name="acceptmethod" value={payData.acceptmethod} />
      </form>

      <button className="btn btn-primary mt-3" onClick={handlePay}>
        결제하기
      </button>
    </div>
  );
};

export default PaymentPage;
